import {
  AddIcon,
  DeleteIcon,
  EditIcon,
} from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  IconButton,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CONDICOES_SEGURO_LABEL } from "@/models/conciliation-config.model";
import { ConfiguracoesTableProps } from "./types";

export function ConfiguracoesTable({
  configuracoes,
  isLoadingConfiguracoes,
  isLoadingConfiguracaoById,
  isSubmittingConfiguracao,
  onNewConfiguracao,
  onEditConfiguracao,
  onDeleteConfiguracao,
}: ConfiguracoesTableProps) {
  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Text fontWeight="bold">Configurações cadastradas</Text>
        <Button size="sm" leftIcon={<AddIcon />} onClick={onNewConfiguracao}>
          Nova configuração
        </Button>
      </Flex>

      {isLoadingConfiguracoes ? (
        <Flex justifyContent="center" py={8}>
          <Spinner />
        </Flex>
      ) : (
        <Box borderWidth="1px" borderRadius="md" overflow="hidden">
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Nome</Th>
                <Th>Ordem</Th>
                <Th>Condição seguro</Th>
                <Th textAlign="right">Ações</Th>
              </Tr>
            </Thead>
            <Tbody>
              {configuracoes.length === 0 && (
                <Tr>
                  <Td colSpan={4} textAlign="center">
                    Nenhuma configuração cadastrada.
                  </Td>
                </Tr>
              )}

              {configuracoes.map((configuracao) => (
                <Tr key={configuracao.id}>
                  <Td>{configuracao.nome}</Td>
                  <Td>{configuracao.ordem}</Td>
                  <Td>
                    {
                      CONDICOES_SEGURO_LABEL[
                        configuracao.condicaoSeguro ?? "QUALQUER"
                      ]
                    }
                  </Td>
                  <Td>
                    <Flex justifyContent="end" gap={2}>
                      <IconButton
                        aria-label="editar-configuracao"
                        size="sm"
                        icon={<EditIcon />}
                        onClick={() => void onEditConfiguracao(configuracao.id)}
                        isLoading={isLoadingConfiguracaoById}
                      />
                      <IconButton
                        aria-label="excluir-configuracao"
                        size="sm"
                        colorScheme="red"
                        icon={<DeleteIcon />}
                        onClick={() => void onDeleteConfiguracao(configuracao.id)}
                        isLoading={isSubmittingConfiguracao}
                      />
                    </Flex>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}
    </>
  );
}